import jQuery from 'jquery';

;(function($){

//========================================================
//
// ■XJStorageLoaderクラス定義
//
//========================================================
$(function(){
	const $this = $('#irRelevance');
	if(!$this.length) return;

  $this.prepend('<div data-id="xj-title"></div>');
  $this.find('[data-id="tab"]').prepend(
    '<div class="p-irNewsListTab-nav" data-id="xj-select-year"></div>' +
    '<div class="p-irNewsListTab-body">' +
      '<ul class="c-irNewsList" data-id="xj-mainlist"></ul>' +
    '</div>'
  );


  /*========================================================
    コンストラクタAS80522
  ========================================================*/
  var XjStorageLoaderLibraryKessan = function(s)
  {
    var defaults = {
      domain:'https://www.xj-storage.jp',
      company:    'AS80522',
      code_kessan:'98',
      display_id_kessan:'xj-mainlist'
    };

    this.settings = $.extend ( defaults, s ) ;
    this.xjlist_kessan = [];
    this.select_latest = '';
    this.select_oldest = '';
    this.active_select = '';

    //initメソッド実行
    XjStorageLoaderLibraryKessan.prototype.init.call ( this ) ;
    };

  /*========================================================
    初期設定
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.init = function()
  {
    $.ajaxSetup ( { scriptCharset:'utf-8' } ) ;

    var self = this ;
    var code_all = self.settings.code_kessan ;
    var url_all = self.createUrl ( code_all ) ;

    self.setMaxMinYear ( url_all ) ;
  };

  /*========================================================
    情報取得用URL生成
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.createUrl = function(code)
  {
    var self = this ;
    var xjurl ;

    xjurl = self.settings.domain + '/public-list/GetList.aspx?company=';
    xjurl+= self.settings.company ;

    if ( self.settings.len && self.settings.len > 0 )
    {
      xjurl+= '&len=' + self.settings.len ;
    }
    else
    {
      xjurl+= '&len=10000' ;
    }

    if ( code && code.length > 0 )
    {
      xjurl+= '&doctype=' + code ;
    }

    //xjurl+= '&filetype=PDF-GENERAL';
    xjurl+= '&output=json&callback=?';

    //clipboardData.setData('text',xjurl);

    return xjurl;
  }

  /*========================================================
    年選択ボタン生成
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.setMaxMinYear = function ( xjurl )
  {
    var self = this ;

    $.ajax (
    {
      url: xjurl,
      dataType: 'json',

      success : function ( data )
      {

        if ( !data.items )
        {
          return ;
        }
        
        $.each ( data.items, function ( i, item )
        {
          var fiscalyear = self.getFiscalYear ( item.title ) ;

          if ( "" == fiscalyear )
          {
            var date = item.publishDate.split(' ')[0].split('/');
            fiscalyear = parseInt ( date[0] ) ;
          }


          //最新の年月期と最古の年月期を取得
          if ( self.select_latest === '' )
          {
            self.select_latest = fiscalyear ;
          }

          if ( self.select_oldest === '' ||
              self.select_oldest >= fiscalyear )
          {
            self.select_oldest = fiscalyear ;
          }

        });

      },

      complete : function()
      {
        self.setDateButton ( ) ;
      }
    });
  }

  /*========================================================
    年選択ボタン生成
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.setDateButton = function()
  {
    var self = this ;

    self.active_select = self.select_latest ;

    var ul = $( '<ul class="xj_tab_btn"></ul>' ) ;

    if ( '' != self.select_latest )
    {
    
      for ( var i = self.select_latest, j = 0 ;
        i >= self.select_oldest ; i-- , j++ )
      {
        if ( i == self.active_select )
        {
          var tmp = $( '<li class="item current"></li>' ) ;
        }
        else
        {
          var tmp = $( '<li class="item"></li>' ) ;
        }

      ul.append ( tmp ) ;
      setCallback ( tmp, i ) ;
      }
    }

    function setCallback ( _tmp, _i )
    {
      _tmp.append ( '<a href="javascript:void(0);"><span>' +_i + '年6月期</span></a>' ).click( function ( )
      {
        $this.find( '[data-id="xj-select-year"] .current' ).attr ( 'class', 'item' ) ;

        $( this ).attr ( 'class', 'item current' ) ;

        self.setDuration ( _i ) ;
      }
      );
    }

    $this.find( '[data-id="xj-select-year"]' ).append ( ul ) ;



    self.setDuration(self.active_select);
  }

  /*========================================================
    0000年6月期取得（戻り値：0000）
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.getFiscalYear = function ( title )
  {
    var self = this ;
    var fiscalyear ;
    var res ;

    //スペース削除
    title = self.spaceTrim ( title ) ;

    //判定パターン
    var regexp1 = /平成([0-9０-９]{2})年/ ;
    var regexp2 = /([0-9０-９]{4})年/ ;

    var ki ;

    if ( ( res = regexp1.exec ( title ) ) !== null )
    {
      ki = Number ( self.zen2han ( res[ 1 ] ) ) ;
      fiscalyear = self.heiseiToSeireki ( ki ) ;
    }
    else if ( ( res = regexp2.exec ( title ) ) !== null )
    {
      ki = Number ( self.zen2han ( res[ 1 ] ) ) ;
      fiscalyear = ki ;
    }

    return fiscalyear ;
  }


  /*========================================================
    絞込み期間更新
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.setDuration = function ( n )
  {
    var self = this ;
    self.active_select = n ;

    this.xjlist_kessan.length = 0 ;

    /* 記事生成
    -------------------------------------------------------*/
    var url_kessan = self.createUrl ( self.settings.code_kessan ) ;
    self.prepareList ( self.xjlist_kessan, url_kessan,
        self.settings.display_id_kessan ) ;
  }


  /*============================================
    空白除去
  ============================================*/
  XjStorageLoaderLibraryKessan.prototype.spaceTrim = function(str) {
    return str.replace(/[ 　\t\r\n]+/g, "");
  }

  /*============================================
    全角英数を半角に変換
  ============================================*/
  XjStorageLoaderLibraryKessan.prototype.zen2han = function(str){
    return str.replace(/[０-ｚ]/g,function($0){
      return String.fromCharCode(parseInt($0.charCodeAt(0))-65248);
    });
  }

  /*============================================
    平成を西暦に変換
  ============================================*/
  XjStorageLoaderLibraryKessan.prototype.heiseiToSeireki = function ( y )
  {
    if ( ( y > 0 ) && ( y < 99 ) )
    {
        return ( 1988 + y ) ;
    }
  }

  /*========================================================
    年度振り分け情報込みの情報格納
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.prepareList = function ( xjlist, xjurl,
      display_id )
  {
    var self = this ;

    $.ajax (
    {
      url: xjurl,
      dataType: 'json',

      success : function ( data )
      {
        if ( undefined == data.items )
        {
          return ;
        }

        $.each ( data.items, function ( i, item )
        {
          var onelist = {} ;

          // ファイル関連のプロパティ生成
          if ( item.files )
          {
            $.each ( item.files, function ( j, file )
            {
              if ( file.type == 'PDF-GENERAL')
              {
                onelist.url = file.url ;
                onelist.size = parseInt ( file.size ) ;
                onelist.page = file.page  ;
              }
            }
            ) ;
          }
          
          if ( !onelist.url )
          {
            onelist.url = '' ;
          }

          if ( !onelist.size )
          {
            onelist.size = 0 ;
          }

          if ( !onelist.page )
          {
            onelist.page = 0 ;
          }

          //ファイルサイズの生成
          if ( onelist.size > 0 )
          {
            if ( onelist.size > 1000000 )
            {
              onelist.size = parseInt ( onelist.size / 1000000 ) + 'M' ;
            }
            else if ( onelist.size > 1000 )
            {
              onelist.size = parseInt ( onelist.size / 1000 ) + 'K' ;
            }
          }
          else
          {
            onelist.size = '－' ;
          }

          //ページ数の生成
          if ( onelist.page > 0 )
          {
            onelist.page = onelist.page ;
          }
          else
          {
            onelist.page = '－';
          }

          //タイトル文
          onelist.title = item.title ;

          //0000年6月期を取得
          onelist.fiscalyear = self.getFiscalYear ( item.title ) ;

          if ( "" == onelist.fiscalyear )
          {
            var date = item.publishDate.split(' ')[0].split('/');
            onelist.fiscalyear = parseInt ( date[0] ) ;
          }

          // 日付関連
          onelist.date = item.publishDate.split ( ' ' )[ 0 ].split ( '/' ) ;
          onelist.date_format = onelist.date[ 0 ] + '.' +
              onelist.date[ 1 ] + '.' + onelist.date[ 2 ] ;

          //XJ-Storageリストに格納
          xjlist.push ( onelist ) ;
        }
        ) ;
      },

      complete : function ( )
      {
        self.show ( xjlist, display_id ) ;
      }
    }
    ) ;
  }

  /*========================================================
    表示処理
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.show = function ( xjlist, display_id )
  {
    var self = this ;
    var cont = '' ;
    var repeat_cont = '' ;
    
    /* タイトル
    -----------------------------------------------*/
    $this.find('[data-id="xj-title"]').empty();
    if( self.active_select !== ""){
      $this.find('[data-id="xj-title"]').html('<h2 class="c-title c-title-large">' + self.active_select + '年6月期</h2>');
    }
    

    /* メイン出力内容
    -----------------------------------------------*/
    $this.find( '[data-id="' + display_id + '"]').empty ( ) ;

    for ( var i = 0 ; i < xjlist.length ; i++ )
    {
      var xj_data = xjlist[ i ] ;

      //年度絞り込み
      if ( self.active_select !== xj_data.fiscalyear )
      {
        continue ;
      }

      repeat_cont += '<li><dl>';

      repeat_cont += '<dt><span class="date">' + xj_data.date_format + '</span></dt>' ;
          
      if  ( xj_data.url != '')
          {
            repeat_cont += '<dd><a href="' + xj_data.url + '" target="_blank" class="link_pdf fade normal">';
          }
      if ( xj_data.url != '' && xj_data.size != '－' )
          {
            repeat_cont += ' <span class="icon">【PDF】</span>' ;
          }
      repeat_cont += '<span class="txt">' + xj_data.title ;
      
      
      if ( xj_data.url != '' && xj_data.size != '－' )
          {
            repeat_cont += ' (' + xj_data.size + 'B/' + xj_data.page + 'P）' ;
          }
          
      
      if ( xj_data.url != '' )
          {
            repeat_cont += '</span></a></dd></dl>' ;
          }
          
      
          
      repeat_cont += '</li>' ;
    }

    if ( repeat_cont !== '' )
    {
      cont += repeat_cont;
    }
    else
    {
      cont += '<li class="notxt"><span>ただいま掲載すべき事項はございません。</span></li>' ;
    }
    $this.find( '[data-id="' + display_id + '"]' ).html( cont );
  }

  var xj_storage_loader = new XjStorageLoaderLibraryKessan();
});

}(jQuery));